<template>
  <div class="pay-info stack-sm">
    <div class="pay-info__heading">
      Бесплатный доступ <br> до {{ dateFormatted }}
    </div>
    <div class="pay-info__para">Для продолжения работы, необходимо оплатить счет</div>
    <div class="pt-12">
      <el-button class="w-100" type="primary">Оплатить</el-button>
    </div>
  </div>
</template>

<script>
  import { formatDate } from '@/utils'

  export default {
    props: {
      expireDate: String
    },

    computed: {
      dateFormatted() {
        return formatDate(this.expireDate, { month: 'long', day: 'numeric' })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .pay-info {
    padding: 28px 24px 24px;
    background: $primary-lightest-color;
    color: $primary-color;
  }
  .pay-info__heading {
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
  }
  .pay-info__para {
    opacity: .7;
  }
</style>
